import { useQuery } from "@tanstack/react-query";
import { Plus, Search } from "lucide-react";
import { useState } from "react";
import { api } from "../lib/api";

interface Props {
  selectedId: string | null;
  folderId: string | null;
  onSelect: (id: string) => void;
  onCreate: () => void;
}

export function NoteList({ selectedId, folderId, onSelect, onCreate }: Props) {
  const [q, setQ] = useState("");

  const { data: notes, isLoading } = useQuery({
    queryKey: ["notes", q, folderId ?? "all"],
    queryFn: () => api.listNotes({ q: q || undefined, limit: 100, folder_id: folderId }),
  });

  return (
    <aside className="flex h-full w-72 flex-col border-r border-zinc-800 bg-zinc-950">
      <div className="flex items-center gap-2 border-b border-zinc-800 p-3">
        <div className="relative flex-1">
          <Search className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Suche…"
            className="w-full rounded-md border border-zinc-800 bg-zinc-900 py-1.5 pl-8 pr-2 text-sm focus:border-emerald-600 focus:outline-none"
          />
        </div>
        <button
          onClick={onCreate}
          title="Neue Note"
          className="rounded-md border border-zinc-800 bg-zinc-900 p-1.5 hover:border-emerald-600 hover:text-emerald-400"
        >
          <Plus className="h-4 w-4" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto">
        {isLoading && <div className="p-3 text-xs text-zinc-500">Lade…</div>}
        {notes && notes.length === 0 && (
          <div className="p-3 text-xs text-zinc-500">Keine Notes — leg eine an.</div>
        )}
        <ul>
          {notes?.map((n) => (
            <li key={n.id}>
              <button
                onClick={() => onSelect(n.id)}
                className={`w-full border-l-2 px-3 py-2 text-left text-sm hover:bg-zinc-900 ${
                  selectedId === n.id
                    ? "border-emerald-500 bg-zinc-900 text-white"
                    : "border-transparent text-zinc-300"
                }`}
              >
                <div className="truncate font-medium">{n.title}</div>
                <div className="mt-0.5 truncate font-mono text-[10px] text-zinc-500">
                  {n.type} · v{n.version} · {new Date(n.updated_at).toLocaleString("de-DE")}
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
